"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.OsmosysResourceSelectBoxOption = ({ children, }) => {
    return react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true }, children);
};
exports.OsmosysResourceSelectBoxOption.Icon = ({ children }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginRight: true }, children));
};
exports.OsmosysResourceSelectBoxOption.Label = ({ children }) => {
    return react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true }, children);
};
exports.OsmosysResourceSelectBoxOption.Badge = ({ children }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginLeft: "sm", className: "small text-muted" }, children));
};
//# sourceMappingURL=Option.js.map